import { render, staticRenderFns } from "./TiptapFormatDropdown.vue?vue&type=template&id=ae68cd1c"
import script from "./TiptapFormatDropdown.vue?vue&type=script&lang=ts"
export * from "./TiptapFormatDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports